import { getWorkGuide, isRetiredGuide } from '@/content/workGuideCatalog';
import { API_HOST } from '@/constants/config';

const toQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    searchParams.set(key, String(value));
  });
  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

const fetchGuide = async (path, params = {}) => {
  const url = `${API_HOST}${path}${toQueryString(params)}`;
  let response;

  try {
    response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Platform': 'web',
      },
    });
  } catch {
    throw new Error('Network error — unable to reach the guide service.');
  }

  const contentType = response.headers.get('content-type') || '';
  if (!contentType.includes('application/json')) {
    throw new Error(
      response.ok
        ? 'Guide service returned an unexpected response.'
        : `Guide service returned ${response.status}.`,
    );
  }

  const data = await response.json();
  if (!response.ok || data?.error) {
    throw new Error(data?.message || 'Failed to fetch guide data');
  }

  return data;
};

export const guideApi = {
  getPage: async (guideType, slug) => {
    const type = String(guideType || '').toLowerCase();
    const s = !slug || slug === 'index' ? 'index' : String(slug).toLowerCase();
    if (isRetiredGuide(type, s)) return null;
    const shipped = getWorkGuide(type, s);
    if (shipped) return shipped;
    try {
      const data = await fetchGuide(`/json/guides/${encodeURIComponent(type)}/${encodeURIComponent(s)}`);
      return data.page || null;
    } catch {
      return null;
    }
  },

  getNavigation: async (guideType) => {
    const type = String(guideType || '').toLowerCase();
    try {
      const data = await fetchGuide('/json/guides/navigation', { type });
      return data.sections || [];
    } catch {
      return [];
    }
  },
};

export default guideApi;
